module.exports = __webpack_public_path__ + "img/banner.0d267f59.png";